module.exports = "<div> <p class=test> 123uy1iu2y </p> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/_tpl/index.vue
 ** module id = 153
 ** module chunks = 0
 **/